module.exports = __webpack_public_path__ + "static/media/play_icon.01d4bda1.svg";